import React, { Fragment, useEffect, useState } from "react";
import Link from "react-router-dom/Link";
import $ from "jquery";
import connect from "react-redux/lib/connect/connect";
import { dateFormation, isEmpty, isMobilePage, toastr } from "../../common/cores";
import MobileVisual from "../../components/common/MobileVisaul";
import PCVisual from "../../components/common/PCVisaul";
import {
  GetDepositList,
  GetRealTimeExchangeData,
  GetWithDrawList
} from "../../common/actions/moreAction";
import { SetPageInfo } from "../../common/actions/pageAction";
import { GetDashboardSportsList, GetSportsList } from "../../common/actions/sportsAction";
// import { visual } from "../../utils";

const Menus = [
  {
    name: "라이브카지노",
    Ename: "Live Casino",
    path: "/casino",
    img: "../images/main_game01.png"
  },
  {
    name: "슬롯게임",
    Ename: "Slot Game",
    path: "/slot",
    img: "../images/main_game02.png"
  },
  // {
  //   name: "스포츠",
  //   Ename: "Sports",
  //   path: "/sportsprematch",
  //   img: "../images/main_game03.png"
  // },
  // {
  //   name: "미니게임",
  //   Ename: "Mini Game",
  //   path: "/minigame",
  //   img: "../images/main_game04.png"
  // }
];

const Dashboard = (props) => {
  const { isAuthenticated } = props.user;
  // const isAuthenticated  = props.user.isAuthenticated;
  const roomObj = {
    pageType: "toto",
    sportType: "sport",
    gameType: "live",
    sportId: "all",
    esportType: "all",
    sort: "time",
    location: "all",
    page: 1,
    perPage: 10
  };
  let gamelists = [],
    depositlists = [],
    withdrawlists = [];
  const getLists = page => {
    props.SetPageInfo(roomObj);
  };

  gamelists = props.sports.data;

  depositlists = props.more.realDeposite.data;
  withdrawlists = props.more.realWithdraw.data;

  useEffect(() => {
    const roomObj = {
      pageType: "toto",
      sportType: "sport",
      gameType: "live",
      sportId: "all",
      esportType: "all",
      sort: "time",
      location: "all",
      page: 1,
      perPage: 10
    };

    props.GetDashboardSportsList(roomObj);

    if (props.user.isAuthenticated) getLists(1);
    new window.Swiper({
      el: ".main_best_list",
      slidesPerView: 5, //레이아웃 뷰 개수
      spaceBetween: 25, // 슬라이드 사이 여백
      centeredSlides: true, //센터모드
      loop: true, // 슬라이드 반복 여부
      autoplay: true,
      loopAdditionalSlides: 1, // 슬라이드 반복 시 마지막 슬라이드에서 다음 슬라이드가 보여지지 않는 현상 수정
      slideToClickedSlide: true, // 해당 슬라이드 클릭시 슬라이드 위치로 이동
      initialSlide: 0,
      grabCursor: false,
      scrollbar: {
        el: ".swiper-scrollbar"
      },
      mousewheel: {
        enabled: false
      },
      keyboard: {
        enabled: false
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        // 1024: {
        //     slidesPerView: 5
        // },
        // 520: {
        //     slidesPerView: 1
        // }
      }
    });
  }, []);

  const [day, setDay] = useState("");

  const getDay = () => {
    setInterval(() => {
      let time = new Date();
      setDay(dateFormation(time));
    }, 1000);
  };
  // useEffect(()=>{
  //     getDay();
  // });

  useEffect(() => {
    // visual();
    let time = new Date();
    // setDay( dateFormation(time));
    $("#slide_time").html(dateFormation(time));
    setInterval(() => {
      let time = new Date();
      // setDay( dateFormation(time));
      $("#slide_time").html(dateFormation(time));
    }, 1000);
  }, []);

  useEffect(() => {
    props.GetRealTimeExchangeData(1);
    props.GetRealTimeExchangeData(-1);

    const depositeInterval = setInterval(props.GetRealTimeExchangeData(1), 150000);
    const withdrawInterval = setInterval(props.GetRealTimeExchangeData(-1), 150000);

    return () => {
      clearInterval(depositeInterval);
      clearInterval(withdrawInterval);
    }

  }, [])

  const mainMenu = (menu, index) => {
    if (isAuthenticated)
      return (
        <li key={index}>
          <Link to={menu.path}>
            <img src={menu.img} alt="" />
            <div className="main_game_text1">{menu.Ename}</div>
            <div className="main_game_text2">{menu.name}</div>
          </Link>
        </li>
      );
    else
      return (
        <li key={index}>
          <Link
            to={menu.path}
            onClick={e => {
              e.preventDefault();
              toastr.warning("로그인하시고 이용해주세요.");
            }}
          >
            <img src={menu.img} alt="" />
            <div className="main_game_text1">{menu.Ename}</div>
            <div className="main_game_text2">{menu.name}</div>
          </Link>
        </li>
      );
  };

  const [style, setStyle] = useState({});

  const handleResize = () => {
    if (window.innerWidth <= 991) {
      setStyle({
        top: isAuthenticated ? '90px' : '140px',
      });
    }
    else {
      setStyle({
        top: '140px',
      });
    }
  };

  useEffect(() => {
    handleResize(); // 초기 화면 크기 확인
    window.addEventListener('resize', handleResize); // 리사이즈 이벤트 리스너 추가

    return () => {
      window.removeEventListener('resize', handleResize); // 리스너 제거
    };
  }, []);

  return (
    <Fragment>
      <MobileVisual />
      <div className="slideshow2_wrap" style={style}>
        <div className="slideshow2_wrap_center ">
          <div id="number_slideshow" className="number_slideshow ">
            <ul className="">
              {/* <li className="">
                <a>
                  <img className="" src="../images/slideshow1.png" alt="" />
                </a>
              </li>
              <li className="">
                <a>
                  <img className="" src="../images/slideshow2.png" alt="" />
                </a>
              </li> */}
              <li className="">
                <a>
                  <img className="" src="../images/slideshow4.png" alt="" style={{ width: '1920px' }} />
                </a>
              </li>
            </ul>
            <div id="slide_time" className="slide_time" />
            <div className="slide_notice" style={{ width: "auto" }}>
              <img src="images/notice_title.png" alt="" />
              입금전 계좌 확인은 필수 입니다. 계좌 문의 후 입금신청 해주시기
              바랍니다.
            </div>
            {/* <div className="slide_event">
              <a>
                <img src="images/event01.png" alt="" />
              </a>
            </div> */}
          </div>
        </div>
      </div>
      {/* <PCVisual/> */}
      <div className="main_game_wrap">
        <div className="main_game_box">
          <div className="main_game ">
            <ul className="margin-auto justify-content-center flex-wrap">
              {Menus.map((menu, index) => {
                return mainMenu(menu, index);
              })}
              {/* <li><Link to="/casino"><img src="../images/main_game01.png" alt="" /><div className="main_game_text1">Live Casino</div><div className="main_game_text2">라이브카지노</div></Link></li>
                            <li><Link to="/slot"><img src="../images/main_game02.png" alt="" /><div className="main_game_text1">Slot Game</div><div className="main_game_text2">슬롯게임</div></Link></li>
                            <li><Link to="/sportsprematch"><img src="../images/main_game03.png" alt="" /><div className="main_game_text1">Sports</div><div className="main_game_text2">스포츠</div></Link></li>
                            <li><Link to="/minigame"><img src="../images/main_game04.png" alt="" /><div className="main_game_text1">Mini Game</div><div className="main_game_text2">미니게임</div></Link></li> */}
            </ul>
          </div>
        </div>
      </div>
      <div className="main_board_wrap">
        <div className="main_board_box">
          {/* <div className="main_board_box_left">
            <div className="main_board_left_title">실시간 스포츠</div>
            <div className="main_board">
              <table
                width="100%"
                border="0"
                cellSpacing="0"
                cellPadding="0"
                className="myTable"
              >
                <tbody>
                  {gamelists.map((list, index) => {
                    return (
                      <Fragment key={index}>
                        <tr>
                          <td width="5%" align="center">
                            <img
                              src="../images/icon02.png"
                              style={{ maxWidth: "30px", width: "100%" }}
                              alt=""
                            />
                          </td>
                          <td width="15%" align="center">
                            <span className="board_font1">
                              {!isEmpty(list.Fixture.StartDate) &&
                                dateFormation(list.Fixture.StartDate, 5)}
                            </span>
                          </td>
                          <td width="26%" align="right">
                            {isEmpty(list.Fixture.Participants)
                              ? ""
                              : list.Fixture.Participants[0].name}
                          </td>
                          <td width="16%" align="center">
                            <img src="../images/vs.png" alt="" />
                          </td>
                          <td width="26%" align="left">
                            {isEmpty(list.Fixture.Participants)
                              ? ""
                              : list.Fixture.Participants[1].name}
                          </td>
                          <td width="12%" align="center">
                            <span className="board_font2">
                              {list.Livescore.Scoreboard.Results[0].Value} :{" "}
                              {list.Livescore.Scoreboard.Results[1].Value}
                            </span>
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div> */}
          <div className="main_board_box_right">
            <div>
              <div className="board">
                <div className="board_title">실시간 출금</div>
                <div className="board_box">
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="0"
                    cellPadding="0"
                    className="myTable"
                  >
                    <tbody>
                      {withdrawlists.map((list, index) => {
                        return (
                          <Fragment key={index}>
                            <tr>
                              <td>
                                <span className="board_font1">
                                  {list.bankname}
                                </span>{" "}
                              </td>
                              <td align="right">
                                <span className="board_font2">
                                  {Number(list.amount).toLocaleString()}
                                </span>
                              </td>
                              <td align="right">
                                {dateFormation(list.created_date, 3)}
                              </td>
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="board">
                <div className="board_title">실시간 입금</div>
                <div className="board_box">
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="0"
                    cellPadding="0"
                    className="myTable"
                  >
                    <tbody>
                      {depositlists.map((list, index) => {
                        return (
                          <Fragment key={index}>
                            <tr>
                              <td>
                                <span className="board_font1">
                                  {list.bankname}
                                </span>{" "}
                              </td>
                              <td align="right">
                                <span className="board_font2">
                                  {Number(list.amount).toLocaleString()}
                                </span>
                              </td>
                              <td align="right">
                                {dateFormation(list.created_date, 3)}
                              </td>
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="item_area item_center">
            <div className="customer_item">
              <a href="#" className="board_banner banner_telegram">
                <div className="banner_info">
                  <img src="/images/img_banner_telegram.png" alt="" className="telegram" />
                </div>
              </a>
            </div>
            <div className="customer_item">
              <a href="#" className="board_banner banner_kakao">
                <div className="banner_info">
                  <img src="/images/img_banner_kakao.png" alt="" className="telegram" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="main_best_wrap">
        <div className="main_best_box">
          <div className="main_best_title">THE SMURFS 게임</div>
          <div className="main_best_wrap_box">
            <div className="swiper-button-next" />
            <div className="swiper-button-prev" />
            <div className="main_best_list">
              <ul className="swiper-wrapper">
                <li className="swiper-slide">
                  <a>
                    <img src="../images/best01.jpg" alt="" />
                  </a>
                </li>
                <li className="swiper-slide">
                  <a>
                    <img src="../images/best02.jpg" alt="" />
                  </a>
                </li>
                <li className="swiper-slide">
                  <a>
                    <img src="../images/best03.jpg" alt="" />
                  </a>
                </li>
                <li className="swiper-slide">
                  <a>
                    <img src="../images/best04.jpg" alt="" />
                  </a>
                </li>
                <li className="swiper-slide">
                  <a>
                    <img src="../images/best05.jpg" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  deposit: state.more.deposit,
  withdraw: state.more.withdraw,
  sports: state.sports,
  page: state.page,
  more: state.more
});

export default connect(
  mapStateToProps,
  { GetWithDrawList, GetDepositList, SetPageInfo, GetSportsList, GetDashboardSportsList, GetRealTimeExchangeData }
)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Sports/Main.js